module.exports = require('../../date-picker/locale/zh_CN');



/** WEBPACK FOOTER **
 ** ./components/calendar/locale/zh_CN.js
 **/